import { Injectable } from '@angular/core';
import { RouteReuseStrategy, ActivatedRouteSnapshot, DetachedRouteHandle } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class CustomReuseStrategy implements RouteReuseStrategy {

  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    // Bu metot, route'un kaydedilip kaydedilmeyeceğini belirler. False dönerse, kaydedilmez.
    return false;
  }

  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle | null): void {
    // Burada herhangi bir şey saklanmayacak.
  }

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    // Kaydedilen bileşen geri yüklenmeyecek.
    return false;
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    // Hiçbir bileşen geri yüklenmeyecek.
    return null;
  }

  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    // Her zaman false dönerse, her rota değişiminde bileşen yok edilip yeniden oluşturulur.
    return future.routeConfig === curr.routeConfig;
  }
}
